<template>
  <div class="content">
    <Header :title="'个人设置'" />
    <div class="wrap">
      <nut-row>
        <div class="briefly">
          <h3 @click="getUa">{{ userInfo.nickName || '暂无昵称' }}</h3>
          <p class="time">
            <span class="times">注册时间:{{ userInfo.createdDate || '暂无注册时间' }}</span>
            <span class="times">登录次数:{{ userInfo.loginCount || '暂无登录次数' }}</span>
          </p>
          <p>上次登录时间: {{ userInfo.lastLoginDate || '暂无上次登录时间' }}</p>
          <div class="portrait">
            <van-uploader
              :max-count="1"
              :before-read="beforeRead"
              :after-read="afterRead"
              :max-size="1024 * 1024 * 5"
              :preview-image="true"
              :show-upload="true"
              @oversize="onOversize"
            >
              <div class="img-wrap">
                <img :src="$resUrl(headPicture)" alt @error="$defImg(require('@/assets/images/avatar-default.png'))">
              </div>
            </van-uploader>
          </div>
        </div>
      </nut-row>
      <nut-row>
        <div class="items-small-wrap">
          <div class="items-small">
            <ul>
              <li>
                <router-link to="/Personal/Setting/Form">
                  <i class="iconfont icon-left">&#xe603;</i>
                  <p>个人设置</p>
                  <i class="iconfont icon-right">&#xe655;</i>
                </router-link>
              </li>
              <li>
                <router-link to="/Personal/Setting/PhoneBind">
                  <i class="iconfont icon-left icon-phone">&#xe63b;</i>
                  <p>修改绑定手机</p>
                  <i class="iconfont icon-right">&#xe655;</i>
                </router-link>
              </li>
              <li v-show="!userInfo.openId" @click.stop="openAuthorization">
                <a>
                  <i class="iconfont icon-left icon-phone">&#xe67c;</i>
                  <p>绑定微信帐号</p>
                  <i class="iconfont icon-right">&#xe655;</i>
                </a>
              </li>
              <li v-show="userInfo.openId" @click.stop="closeAuthorization">
                <a>
                  <i class="iconfont icon-left icon-phone">&#xe67c;</i>
                  <p>取消微信绑定</p>
                  <i class="iconfont icon-right">&#xe655;</i>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </nut-row>
      <p v-show="uaInfo.show">{{ uaInfo.ua }} {{ uaInfo.isQuark }}</p>
    </div>
    <Footer :active="4" />
  </div>
</template>
<script>
import Vue from 'vue'
import { Uploader } from 'vant'
import { Toast } from '@nutui/nutui'
import { getWeChatCodeAuthorizeUrl, unBindWeChat } from '@/api/Account/index'
import { baseInfo, uploadAvatarImg, setAvatar } from '@/api/Personal/index'
import Header from '@/components/Header/Index'
import Footer from '@/components/Footer/Index'
import Storage from '@/utils/storage'

Vue.use(Uploader)

export default {
  name: 'PersonalCenter',
  components: {
    Header,
    Footer
  },
  data() {
    return {
      headPicture: require('@/assets/images/avatar-default.png'),
      userInfo: {
        nickName: '',
        headPicture: require('@/assets/images/avatar-default.png'),
        hallCount: '',
        currency: '',
        loginCount: '',
        lastLoginDate: '',
        openId: ''
      },
      uaInfo: {
        show: false,
        ua: '',
        isQuark: ''
      }
    }
  },
  mounted() {
    this.initPage()
  },
  methods: {
    initPage() {
      baseInfo().then(res => {
        if (res && res.success) {
          if (res.data) {
            this.userInfo = res.data
            if (!this.$isEmpty(res.data.headPicture)) {
              this.headPicture = this.$resUrl(res.data.headPicture)
            }
            this.userInfo.createdDate = this.$formatDate(res.data.createdDate.slice(0, 10), '/')
            this.userInfo.lastLoginDate = this.$formatDate(res.data.lastLoginDate, '/')
            Storage.localSet('userInfo', res.data)
          }
        } else {
          Toast.fail(res.msg)
        }
      })
    },
    beforeRead(file) {
      const regex = /(.jpg|.jpeg|.png|.bmp)$/
      if (!regex.test(file.type)) {
        Toast.fail('图片格式不支持上传')
        return false
      } else {
        return true
      }
    },
    afterRead(file) {
      this.loading = Toast.loading('头像上传中...', {
        cover: false
      })
      uploadAvatarImg(file.file).then(res => {
        if (res.success) {
          this.loading.hide()
          this.headPicture = this.$resUrl(res.data.url)
          setAvatar(res.data.url).then(res => {
            if (res && res.success) {
              Toast.success('头像设置成功')
            } else {
              Toast.fail('头像设置失败')
            }
          })
        } else {
          this.loading.hide()
          Toast.fail(res.msg)
        }
      })
    },
    onOversize() {
      Toast.fail('文件大小不能超过 5M')
    },
    // 微信号绑定
    openAuthorization() {
      if (!this.$isWeiXin()) {
        Toast.fail('请在微信客户端打开')
        return
      }
      // 接口中返回
      getWeChatCodeAuthorizeUrl('/Account/BindWeChat').then(res => {
        if (res && res.success) {
          window.location.href = res.data
        } else {
          Toast.fail(res.msg)
        }
      })
      this.initPage()
    },
    // 解除微信綁定
    closeAuthorization() {
      unBindWeChat().then(res => {
        if (res && res.success) {
          Toast.success('解除微信绑定成功')
          this.$router.go(0)
        } else {
          Toast.fail(res.msg)
        }
      })
      this.initPage()
    },
    // 浏览器ua
    getUa() {
      this.uaInfo.show = !this.uaInfo.show
      this.uaInfo.ua = window.navigator.userAgent
      if (/Android/.test(this.uaInfo.ua) && /Quark/.test(this.uaInfo.ua)) {
        // eslint-disable-next-line camelcase
        this.uaInfo.isQuark = '夸克浏览器'
      } else {
        // eslint-disable-next-line camelcase
        this.uaInfo.isQuark = ''
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/styles/index.scss';
::v-deep .nut-button.light {
  border: none;
  height: 45px;
  color: #949494;
  font-size: 13px;
}

.content {
  width: 100vw;
  height: auto;
  background: url('~@/assets/images/bg.png') no-repeat bottom;
  background-size: 100% 100%;
  box-sizing: border-box;
  padding: 18px 18px 80px 18px;

  .wrap {
    width: 100%;
    height: auto;
    overflow: hidden;
    position: relative;

    .briefly {
      width: 100%;
      height: 130px;
      box-sizing: border-box;
      overflow: hidden;
      position: relative;

      h3 {
        font-size: 18px;
        color: #333333;
        margin: 0;
        padding: 14px 0 0 0;
        line-height: 30px;
        position: relative;
      }

      p {
        margin: 0;
        padding: 0;
        font-size: 12px;
        color: #999999;
        text-align: left;
        line-height: 30px;
        @extend %ellipsis;
        position: relative;
        box-sizing: border-box;
        padding-right: 90px;
      }
      .time {
        display: flex;
        white-space: nowrap;
        justify-content: space-between;
        .times {
          height: 100%;
          float: left;
          @extend %ellipsis;
        }

        .times:nth-of-type(1) {
          width: 50%;
        }

        .times:nth-of-type(2) {
          width: auto;
          max-width: 50%;
        }
      }

      &-num {
        width: 100%;
        height: 60px;
        box-sizing: border-box;
        padding-right: 100px;
        display: flex;
        justify-content: space-between;
        position: relative;

        .briefly-card {
          width: auto;
          max-width: 33.3%;
          height: 100%;
          float: left;
          border-right: none;

          h2 {
            margin: 0;
            padding: 0;
            text-align: center;
            color: $primary-color;
            @extend %ellipsis;
          }

          p {
            margin: 0;
            padding: 0;
            line-height: 24px;
            color: #686868;
            text-align: center;
            @extend %ellipsis;
          }
        }
      }

      .portrait {
        position: absolute;
        right: 0;
        top: 15px;
        width: 70px;
        height: 70px;
        border-radius: 40px;
        overflow: hidden;
        text-align: center;
        line-height: 70px;
        .img-wrap {
          width: 70px;
          height: 70px;
          border-radius: 40px;
          overflow: hidden;
          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
          }
        }

        .icon-user {
          font-size: 50px;
          color: #ffffff;
        }
        .icon-user {
          font-size: 50px;
          color: #ffffff;
        }
      }
    }

    .items-big-wrap {
      width: 100%;
      height: auto;
      overflow: hidden;
      box-sizing: border-box;
      padding: 0 18px;

      .items-big {
        width: 100%;
        height: 65px;
        background: #ffffff;
        border-top-left-radius: 8px;
        border-top-right-radius: 8px;
        position: relative;
        display: flex;
        justify-content: space-around;
        align-items: center;

        .item {
          width: 120px;
          height: 40px;
          position: relative;

          a {
            display: block;
            width: 100%;
            height: 100%;
            box-sizing: border-box;
            padding-left: 35px;

            img {
              width: 30px;
              height: 30px;
              position: absolute;
              left: 0;
              top: 5px;
            }

            h1 {
              position: relative;
              margin: 0;
              padding: 0;
              font-size: 15px;
              color: #4c4c4c;
            }

            p {
              margin: 0;
              padding: 0;
              color: #4c4c4c;
              font-size: 12px;
            }
          }
        }
      }
    }

    .items-small-wrap {
      width: 100%;
      height: auto;
      overflow: visible;
      min-height: 376px;
      max-height: 437px;
      position: relative;

      .items-small {
        width: calc(100% - 10px);
        height: calc(100% - 10px);
        overflow: hidden;
        position: absolute;
        top: -5px;
        left: 5px;
        background: rgba(255, 255, 255, 0.8);
        border-radius: 8px;
        @extend %boxShadow;
        position: relative;

        ul {
          li {
            width: 100%;
            height: 61px;
            line-height: 61px;
            float: left;
            position: relative;
            font-size: 14px;
            color: #4c4c4c;
            @extend %ellipsis;
            &::after {
              @extend %border-bottom;
            }

            .iconfont {
              color: #d9d9d9;
              font-size: 18px;
            }

            .icon-left {
              margin-right: 6px;
            }

            .icon-right {
              position: absolute;
              right: 20px;
              top: 0;
            }

            a {
              display: block;
              width: 100%;
              height: 100%;
              color: #4c4c4c;
              box-sizing: border-box;
              padding: 0 18px;

              .iconfont {
                color: #d9d9d9;
                font-size: 18px;
                position: absolute;
              }

              .icon-left {
                margin-right: 6px;
                color: #b3b3b3;
                left: 20px;
                top: 0;
              }

              .icon-right {
                position: absolute;
                right: 20px;
                top: 0;
              }

              .icon-left.icon-pay {
                font-size: 22px;
                left: 18px;
              }

              .icon-left.icon-phone {
                font-size: 20px;
                left: 19px;
              }

              p {
                position: relative;
                box-sizing: border-box;
                padding: 0 0 0 28px;
                margin: 0;
              }
            }
          }

          li:nth-last-child(1) {
            border-bottom: none;
          }
        }
      }
    }

    .btn-wrap {
      width: 100%;
      height: 55px;
      overflow: hidden;
      box-sizing: border-box;

      .btn {
        width: calc(100% - 10px);
        height: 45px;
        margin: 5px auto;
        border-radius: 8px;
        overflow: hidden;
        @extend %boxShadow;
      }
    }
  }
}
</style>
